import { css } from '@emotion/css';

import { COLORS } from '@/styles/colors';

export const overlay = css`
  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  padding: 0 24px;
  background-color: ${COLORS.DIM_DARK};

  @media (min-width: 640px) {
    padding: 0;
  }
`;
export const container = css`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
`;

export const content = css`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  width: 100%;
  margin: auto 20px;
  padding: 20px 24px;
  border-radius: 8px;
  background-color: ${COLORS.WHITE};
  box-shadow: 0 2px 1px rgba(22, 24, 29, 0.02), 0px 2px 8px rgba(22, 24, 29, 0.1);

  @media (min-width: 640px) {
    width: 418px;
  }
`;
